import { s } from "../../../../lib/styler";
import Icon from "../../../commons/Icon";

export type MessagingThreadFailedActionMenuProps = {
    iconName: string;
    text: string;
    border?: boolean;
    onClick?: () => void;
}

export default function MessagingThreadFailedActionMenuItem({ iconName, text, border = false, onClick }: MessagingThreadFailedActionMenuProps) {
    return (
        <div className={s("flex pl-[30px] pr-[90px] py-[18px] gap-[38px] text-gray-600 cursor-pointer transition-colors duration-200 bg-gray-100 hover:bg-gray-200 active:bg-gray-200", {
            "border-b border-gray-300": border
        })} onClick={onClick}>
            <Icon name={iconName} />
            <div>{text}</div>
        </div>
    );
}